<agpr-dialog-container
    *ngIf="display"
    [id]="'amplifyDialog'"
    [heading]="localization.headerText"
    (close)="onCloseClick();"
>
    <div class="agpr-amplifyDialog-content">
        <div
            class="agpr-amplifyDialog-flexContainer"
            *ngIf="localization.newStory"
        >
            <div
                class="agpr-amplifyDialog-leftBox"
                ngClass="{{iconClass}}"
                aria-hidden="true"
            ></div>
            <div class="agpr-amplifyDialog-rightBox">
                <div>{{localization.releaseStory}}</div>
                <span>{{localization.newsroom}}</span>
            </div>
        </div>
        <div class="agpr-amplifyDialog-block">
            <agpr-button
                *ngIf="localization.newStory"
                [id]="'amplifyDialog.newButton'"
                [wide]="true"
                [label]="localization.newStory"
                (click)="onNewStoryClick();"
                [style]="buttonTypes.primary"
            ></agpr-button>
            <div
                *ngIf="userOptions && userOptions.length"
                class="agpr-amplifyDialog-blockActions"
            >
                <button
                    *ngFor="let option of userOptions; let i = index;"
                    class="agpr-amplifyDialog-action"
                    [id]="'amplifyDialog.action_' + i"
                    (click)="optionSelected($event, i)"
                >
                    <div
                        class="agpr-amplifyDialog-topBox"
                        ngClass="{{option.icon || iconClass}}"
                    ></div>
                    <div class="agpr-amplifyDialog-middleBox">
                        <span>{{option.name | uppercase}}</span>
                    </div>
                    <div class="agpr-amplifyDialog-bottomBox">
                        <span>{{option.helperText}}</span>
                    </div>
                </button>
            </div>
            <div class="agpr-amplifyDialog-option">
                <span>{{'or' | localize}}</span>
            </div>
            <div  class="agpr-amplifyDialog-existingContentBlock">
                <div class="agpr-amplifyDialog-existingCaption">{{localization.existingContent}}</div>
                <div class="agpr-amplifyDialog-flexContainer">
                    <div *ngIf="dropdownDataSource.length > 1" class="agpr-amplifyDialog-filterDropdown">
                        <agpr-dropdown
                            [(ngModel)]="selectedOption"
                            [id]="'amplifyDialog.dropdown'"
                            [options]="dropdownDataSource"
                            (ngModelChange)="onSelectType($event);">
                        </agpr-dropdown>
                    </div>
                    <div *ngIf="dropdownDataSource && dropdownDataSource.length <= 1" class="agpr-amplifyDialog-filterDropdown">
                        <div class="agpr-amplifyDialog-filterDropdownSingleLabel">
                            {{dropdownDataSource[0]}}
                        </div>
                    </div>
                    <div class="agpr-amplifyDialog-filterText">
                        <agpr-text-input
                            [id]="'amplifyDialog.filterTextInput'"
                            [(ngModel)]="keyword"
                            (ngModelChange)="onFilterTextChange();"
                            [placeholder]="filterPlaceholderText"
                            [bottomMargin]="false"
                            ariaLabel="Amplify.dialogs.newWire.createFromPrevious.filterTextInput.placeholder"
                        ></agpr-text-input>
                    </div>
                </div>
                <div class="agpr-amplifyDialog-list">
                    <agpr-scroll-panel (scrolledToBottom)="onScrollDataLoad()">
                        <ol
                            id="sources"
                            *ngIf="totalRecords != null && totalRecords != 0"
                            class="agpr-list"
                            agprListKeyboardNavigation
                            [list]="dataSource"
                        >
                            <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
                            <li
                                [id]="'amplifyDialog.listItem_' + indexNum"
                                class="agpr-list-item"
                                *ngFor="let story of dataSource; index as indexNum"
                                (keydown)="onRowSelect(story, $event)"
                                (click)="onRowSelect(story)"
                                [ngClass]="{
                                    'agpr-list-item--selected': (selectedRow.id == story.id),
                                    'agpr-list-item--odd':(indexNum % 2) == 0
                                }"
                            >
                                <span class="agpr-list-item-name">
                                    {{ story.name }}
                                </span>
                                <span class="agpr-list-item-type">
                                    {{ story.type }}
                                </span>
                            </li>
                            <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
                        </ol>
                        <div
                            *ngIf="isLoading"
                            class="agpr-amplifyDialog-loading"
                            [agprLoading]="true"
                        >
                        </div>
                    </agpr-scroll-panel>
                </div>
            </div>
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="'amplifyDialog.cancelButton'"
            [label]="localization.buttonCancel"
            [style]="buttonTypes.secondary"
            (click)="onCancelClick();"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="'amplifyDialog.useSelectedButton'"
            [disabled]="!isRowSelected"
            [tooltip]="!isRowSelected ? localization.buttonDisabledTooltip : null"
            [label]="localization.buttonUseSelected"
            (click)="onUseSelectedClick();"
            [style]="buttonTypes.primary"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>
